// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x-Summary {
  box-shadow: 0 1px 4px 0 rgba(40, 51, 63, 0.14);
  background-color: #FFFFFF;
}
@media screen and (min-width: 1025px) {
  .x-Summary {
    margin: -25px 15px;
  }
}
.x-Summary-content {
  padding: 11px 11px;
}
@media screen and (min-width: 1000px) {
  .x-Summary-content {
    padding: 11px 81px;
  }
}
`, "",{"version":3,"sources":["webpack://./modules/portal-core/components/Summary.less"],"names":[],"mappings":"AAEA;EACE,8CAAA;EACA,yBAAA;AADF;AAEE;EAAA;IACE,kBAAA;EACF;AACF;AAEA;EACE,kBAAA;AAAF;AACE;EAAA;IACE,kBAAA;EAEF;AACF","sourcesContent":["@import '../styles/theme.less';\n\n.root {\n  box-shadow: 0 1px 4px 0 rgba(40, 51, 63, 0.14);\n  background-color: @color-bg;\n  @media screen and (min-width: 1025px) {\n    margin: -25px 15px;\n  }\n}\n\n.content {\n  padding: 11px 11px;\n  @media screen and (min-width: 1000px) {\n    padding: 11px 81px\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `x-Summary`,
	"content": `x-Summary-content`
};
export default ___CSS_LOADER_EXPORT___;
